import { Box, Typography } from '@mui/material';
import { SearchOff as SearchOffIcon } from '@mui/icons-material';
import React from 'react';
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '90vh',
      }}>
      <Typography variant='h1' color='primary'  style={{fontFamily:'Poppins', fontWeight:'500'}}>
        <SearchOffIcon fontSize='x-large' style={{position: 'relative' ,top: 10}}/>
        Page Not Found
      </Typography>
      <br/>

      <Link to="/"  color='primary' style={{fontFamily:'Poppins', textDecoration:'none'}} >
      <Typography variant='h6' color='primary'>
        Go to Home Page
      </Typography>
      </Link>
        
    </Box>
  );
}
